import React from "react";

import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";

import BatchDetail from "../../../common/BatchDetail";
import { portinColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPortin, __portinStatusPWG } from "../../../../api/sim";
import useAxios from "../../../../hooks/useAxios";
import useAlert from "../../../../hooks/useAlert";

const COPY_KEYS = ["id", "batch_id", "iccid", "msisdn", "status", "plan_id", "last_updated"];

const RecheckPortStatusButton = ({ data }) => {
  const { setAlertMessage } = useAlert();
  const [statusResponse, statusCall, statusLoading] = useAxios({
    ...__portinStatusPWG,
  });

  React.useEffect(() => {
    if (statusResponse && statusResponse.status) {
      setAlertMessage({ type: "success", message: "Portin status recheck queued" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusResponse]);

  return (
    <Grid item sx={{ mb: "10px" }}>
      <Button
        variant="contained"
        color="primary"
        disabled={statusLoading || !data.length}
        onClick={() => statusCall({ data: data.map((line) => line.id) })}
      >
        Recheck Port Status
      </Button>
    </Grid>
  );
};

const PortinBatch = () => (
  <BatchDetail
    title="Portin"
    apiGet={__getPortin}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) => portinColumns({ ...ctx, iccidHeaderName: "ESN", msisdnHeaderName: "MDN" })}
    copyKeys={COPY_KEYS}
    exportAction="portin"
    retryOperation="portin"
    showTerminate
    extraActions={({ data }) => <RecheckPortStatusButton data={data} />}
    getRowPath={(row) => `/pwg/portin/${row.id}`}
  />
);

export default PortinBatch;
